import graphql from "babel-plugin-relay/macro";

import { useMutationWithError } from "../../../../utils/hooks/useMutationWithError";
import {
  CreateMultiSlotBookingsInput,
  useCreateNewMultiSlotBookingMutation,
} from "./__generated__/useCreateNewMultiSlotBookingMutation.graphql";

export const useCreateNewMultiSlotBooking = () => {
  const [createNewMultiSlotBooking, isCreating] =
    useMutationWithError<useCreateNewMultiSlotBookingMutation>(
      useCreateNewMultiSlotBookingMutationString
    );

  const handleCreateNewMultiSlotBooking = (
    input: CreateMultiSlotBookingsInput,
    onComplete: (bookingId: string) => void
  ) => {
    createNewMultiSlotBooking({
      variables: { input },
      onCompleted: (res) => {
        if (res?.responsePayload?.success) {
          const bookingId = res.responsePayload?.bookings?.find(
            (booking) => booking?.id
          )?.id;
          if (bookingId) {
            onComplete(bookingId);
          }
        }
      },
    });
  };

  return [handleCreateNewMultiSlotBooking, isCreating] as const;
};

const useCreateNewMultiSlotBookingMutationString = graphql`
  mutation useCreateNewMultiSlotBookingMutation(
    $input: CreateMultiSlotBookingsInput!
  ) {
    responsePayload: createMultiSlotBookings(input: $input) {
      errors {
        field
        code
        message
      }
      success
      startSlots {
        id
      }
      bookings {
        id
      }
    }
  }
`;
